import React, { useContext, useEffect, useState } from "react";
import colors, {
  StyledForm,
  Success,
  Cancel,
} from "../../../components/300/UiComponent";
import { useFormik, Formik, Form } from "formik";
import * as yup from "yup";
import CourseContext from "../../../context/CourseContext";
import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  Alert,
  Autocomplete,
  Grid,
} from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../../components/300/styles";
// import api from "./../../../api/mainApi";
import CustomizedSnackbars from "./CustomizedSnackbars";
import OfficeContext from "../../../context/OfficeContext";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const department = [
  { name: "", value: "", label: "" },
  {
    name: "software_department",
    value: "software_engineering_dep",
    label: "Software Department",
  },
  {
    name: "electrical_department",
    value: "electrical_engineering_dep",
    label: "Electrical Department",
  },
  {
    name: "mechanical_department",
    value: "mechanical_departmentt",
    label: "Mechanical Department",
  },
  {
    name: "civil_department",
    value: "civil_department",
    label: "Civil Department",
  },
];
const program_type = [
  { name: "bsc", value: "BSc", label: "BSc" },
  { name: "msc", value: "MSc", label: "MSc" },
  { name: "phd", value: "PhD", label: "PhD" },
];
const admission_type = [
  { name: "reg", value: "Regular", label: "Regular" },
  { name: "ext", value: "Extension", label: "Extension" },
  { name: "summer", value: "Summer", label: "Summer" },
];

const validationSchema = yup.object({
  name: yup
    .string("Enter the curriculum name")
    .required("Curriculum name is required"),
  owner: yup.string("Enter the owner").required("Owner is required"),
  program_type: yup
    .string("Enter the program type")
    .required("Program type is required"),
  admission_type: yup
    .string("Enter the admission type")
    .required("Admission type is required"),
  stream: yup.string("Enter the stream/program").required("stream is required"),
  programDuration: yup
    .number("Enter the program duration")
    .required("Program duration is required"),
  starting_date: yup
    .date("Enter the effective date")
    .required("Effective date is required"),
});

function EditCurriculum() {
  const api = useAxiosPrivate();
  const location = useLocation();
  const navigate = useNavigate();
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const [streams, setStreams] = useState([]);
  const officeContext = useContext(OfficeContext);
  const courseContext = useContext(CourseContext);

  let curriculum = courseContext.curriculumState.filter((elem) => {
    return elem.id == location.state.id;
  })[0];
  console.log(curriculum);
  //const = useFormik({
  //  initialValues: {
  //    name: curriculum.name,
  //    owner: curriculum.owner,
  //    program_type: curriculum.program_type,
  //    admission_type: curriculum.admission_type,
  //    stream: curriculum.stream,
  //    payment_rate: curriculum.payment_rate,
  //    starting_date: curriculum.starting_date,
  //  },
  //  validationSchema: validationSchema,
  //  onSubmit: (values) => {
  //    const newValues = { ...values, id: location.state.id, active: 1 };
  //    // api
  //    //   .patch("/curriculum/updateCurriculum", newValues)
  //    //   .then((response) => {
  //    //     alert(JSON.stringify(response, null, 2));
  //    //     setMessage({
  //    //       message: "Updated Successfully",
  //    //       type: "success",
  //    //     });
  //    //     setSnackBarOpen(true);
  //    //   })
  //    //   .then(() => {
  //    //     courseContext.curriculumDispatch({
  //    //       type: "updateCurriculum",
  //    //       curriculum: values,
  //    //     });
  //    //   })
  //    //   .catch((err) => {
  //    //     alert(JSON.stringify(err.response.data, null, 2));

  //    //     //not worked yet
  //    //     setMessage({
  //    //       message: "Curriculum name already taken!",
  //    //       type: "error",
  //    //     });
  //    //   });

  //    alert(JSON.stringify(values, null, 2));
  //  },
  //});
  useEffect(() => {
    let stream = courseContext.curriculumState
      .map((c) => c.stream)
      .filter((c) => Boolean(c));
    setStreams(stream?.filter((val, index) => stream.indexOf(val) == index));

    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
  }, []);
  return (
    <>
      <Formik
        initialValues={{
          name: curriculum.name,
          owner: curriculum.owner.id,
          program_type: curriculum.program_type,
          admission_type: curriculum.admission_type,
          stream: curriculum.stream,
          programDuration: curriculum.programDuration,
          starting_date: curriculum.starting_date,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const newValues = { ...values, id: location.state.id };
          api
            .patch("/curriculum/updateCurriculum", newValues)
            .then((response) => {
              alert(JSON.stringify(response, null, 2));
              navigate("../", {
                state: {
                  message: {
                    message: "Updated Successfully",
                    type: "success",
                  },
                  open: true,
                },
              });
            })
            .catch((err) => {
              alert(JSON.stringify(err.response.data, null, 2));
              setMessage({
                message: err.response.data.message || "Error Occured",
                type: "error",
              });
            });
        }}
      >
        {({
          handleChange,
          values,
          setFieldValue,
          errors,
          touched,
          handleSubmit,
        }) => (
          <Form
            style={{
              //border: "1px solid black",
              width: "100%",
              padding: "40px 25px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "30px",
              borderRadius: "8px",
              h3: {
                padding: "0px 10px 30px 0px",
                color: `${colors.primary400}`,
                fontSize: "20px",
                fontWeight: 500,
                flexBasis: "100%",
                borderBottom: `0.5px solid ${colors.third100}`,
              },
              row: {
                display: "flex",
                gap: "15px",
              },
              btnGroup: {
                display: "flex",
                gap: "20px",
                paddingTop: "30px",
                width: "100%",
                justifyContent: "flex-end",
              },
            }}
          >
            <Box sx={header}>
              <Typography
                variant="span"
                sx={{
                  fontSize: "1.14rem",
                  fontWeight: "600",
                  lineHeight: "23.2px",
                  color: "primary.main",
                }}
              >
                Edit Curriculum
              </Typography>
            </Box>
            <Grid container spacing={5}>
              <Grid item xs={12} md={5.5} sx={leftCol}>
                <FormControl sx={groupStyled}>
                  <FormLabel htmlFor="curriculum" sx={labelStyled}>
                    Curriculum Name
                  </FormLabel>
                  <TextField
                    id="name"
                    name="name"
                    onChange={handleChange}
                    error={touched.name && Boolean(errors.name)}
                    value={values.name}
                    helperText={touched.name && errors.name}
                  />
                </FormControl>

                <FormControl sx={groupStyled}>
                  <FormLabel sx={labelStyled}>Owner</FormLabel>
                  <TextField
                    id="owner"
                    name="owner"
                    value={values.owner}
                    onChange={handleChange}
                    error={errors.owner && Boolean(errors.owner)}
                    helperText={touched.owner && errors.owner}
                    fullWidth
                    select
                  >
                    {officeContext.officeState
                      .filter((office) => Number(office.status) == 1)
                      .map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </FormControl>

                <FormControl sx={groupStyled}>
                  <FormLabel id="program_type" sx={labelStyled}>
                    Program Type
                  </FormLabel>
                  <TextField
                    fullWidth
                    //label="program_type"
                    id="program_type"
                    name="program_type"
                    value={values.program_type}
                    onChange={handleChange}
                    error={errors.program_type && Boolean(errors.program_type)}
                    helperText={touched.program_type && errors.program_type}
                    select
                  >
                    {program_type.map((option) => (
                      <MenuItem key={option.name} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>

                <FormControl sx={groupStyled}>
                  <FormLabel id="admission_type" sx={labelStyled}>
                    Admission Type
                  </FormLabel>
                  <TextField
                    fullWidth
                    //label="Admission Type"
                    id="admission_type"
                    name="admission_type"
                    value={values.admission_type}
                    onChange={handleChange}
                    error={
                      errors.admission_type && Boolean(errors.admission_type)
                    }
                    helperText={touched.admission_type && errors.admission_type}
                    select
                  >
                    {admission_type.map((option) => (
                      <MenuItem key={option.name} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6.5} sx={col}>
                <Box sx={row}>
                  <FormControl sx={groupStyled} fullWidth>
                    <FormLabel sx={labelStyled} htmlFor="stream">
                      Stream/Program (Optional)
                    </FormLabel>

                    <Autocomplete
                      id="autostream"
                      //name="city_id"
                      freeSolo
                      options={streams}
                      value={values.stream}
                      //groupBy={(option) => option.state}
                      //getOptionLabel={(option) => option.name}
                      onChange={(e, newValue) => {
                        console.log(newValue);
                        setFieldValue("stream", newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="stream"
                          name="stream"
                          {...params}
                          onChange={handleChange}
                          value={values.stream}
                          error={errors.stream && Boolean(errors.stream)}
                          helperText={touched.stream && errors.stream}
                        />
                      )}
                    />

                    {/*<TextField
                id="stream"
                name="stream"
                value={values.stream}
                onChange={handleChange}
                error={errors.stream && Boolean(errors.stream)}
                helperText={touched.stream && errors.stream}
              />*/}
                  </FormControl>
                  <FormControl sx={groupStyled} fullWidth>
                    <FormLabel sx={labelStyled} htmlFor="programDuration">
                      Program Duration
                    </FormLabel>
                    <TextField
                      type="number"
                      id="programDuration"
                      name="programDuration"
                      value={values.programDuration}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      error={
                        errors.programDuration &&
                        Boolean(errors.programDuration)
                      }
                      helperText={
                        touched.programDuration && errors.programDuration
                      }
                      InputProps={{
                        inputProps: { min: 1, max: 20 },
                        endAdornment: (
                          <InputAdornment position="end">Years</InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Box>
                <Box sx={row}>
                  <FormControl sx={groupStyled} fullWidth>
                    <FormLabel sx={labelStyled} htmlFor="starting_date">
                      Effective Date
                    </FormLabel>
                    <TextField
                      type="date"
                      id="starting_date"
                      name="starting_date"
                      value={values.starting_date}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      error={
                        errors.starting_date && Boolean(errors.starting_date)
                      }
                      helperText={touched.starting_date && errors.starting_date}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
            <CustomizedSnackbars
              {...{ setSnackBarOpen, snackBarOpen, message }}
            />

            <Box
              sx={{
                display: "flex",
                gap: "1.8rem",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <NavLink to={"../"} style={{ textDecoration: "none" }}>
                <Button variant="outlined" color="third">
                  Cancel
                </Button>
              </NavLink>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "secondary.main",
                  "&:hover": {
                    backgroundColor: "secondary.hover",
                  },
                }}
                type="submit"
              >
                Update
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default EditCurriculum;
